import React, { useState, useReducer, useEffect, useRef } from "react";

import { Link } from "react-router-dom";

import { useHistory } from "react-router-dom";

// Components imports
import NavigationBar from "../../components/common/NavigationBar";
import TableComponent from "../../components/common/TableComponent";
import PapersNavigation from "../../components/common/PapersNavigation";
import Pagination from "../../components/common/Pagination";
import Filter from "../../components/common/Filter";
import Button from "../../components/common/Button";

// Scss imports
import css from "./Papers.module.scss";

// React icons imports
import { RiArrowDownCircleLine } from "react-icons/ri";
import { RiArrowUpCircleLine } from "react-icons/ri";

// redux
import { useSelector, useDispatch } from "react-redux";

import {
  getAllPagePapers,
  getCertainPagePapers,
  allPapersNumber,
  currentYearPapersNumber,
  getCertainCategoryPaperNumber,
  getNotArchivedPagePapers,
} from "../../redux/actions/papersActions";

import {
  getActiveProcessors,
  getProcessors,
} from "../../redux/actions/processorsActions";

import {
  getArchiveOfCurrentUser,
  allArchiveNumber,
  getArchiveOfCurrentUserForCurrentYear,
  currentYearArchiveNumber,
} from "../../redux/actions/archiveActions";

import {
  getCategories,
  getActiveCategories,
} from "../../redux/actions/categoriesActions";

import { processorsReducer } from "../../redux/reducers/processorsReducer";
import { getCurrentUserData } from "../../redux/actions/currentUserActions";
import { convertToObject } from "typescript";
import { getRecipientAndSenders } from "../../redux/actions/papersActions";

interface PapersProps {}

const Papers: React.FC<PapersProps> = () => {
  const dispatch = useDispatch();

  // All categories
  const categoriesAll = useSelector(
    (state: any) => state.allCategories.categories.data
  );

  const categories = useSelector(
    (state: any) => state.allCategories.categoriesActive
  );

  const activeProcessors = useSelector(
    (state: any) => state.allProcessors.processorsActive
  );

  const allProcessors = useSelector(
    (state: any) => state.allProcessors.processors
  );

  // All page papers
  const allPagePapers = useSelector((state: any) => state.papers.allPagePapers);

  // Current year page papers
  const certainPagePapers = useSelector(
    (state: any) => state.papers.certainPagePapers
  );

  // All pages number
  const allPapers = useSelector((state: any) => state.papers.allPapersNumber);

  // All pages number
  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  // Certain year pages number
  const currentYearPapers = useSelector(
    (state: any) => state.papers.currentYearPapersNumber
  );

  // Recipients/Senders
  const allRecipientsSenders = useSelector(
    (state: any) => state.papers.recipientAndSenders
  );

  const [processorsListArray, setProcesorsListArray] = useState<any>([
    { value: "", name: "Изабери" },
  ]);

  const [categoryListArray, setCategoryListArray] = useState<any>([
    { value: "", name: "Изабери" },
  ]);

  const [currentUserRole, setCurrentUserRole] = useState("");

  const [recipientsSendersListArray, setRecipientsSendersListArray] =
    useState<any>([{ value: "", name: "Изабери" }]);

  const [categoriesArray, setCategoriesArray] = useState<any>([{}]);

  useEffect(() => {
    // Setting up categories array
    setCategoriesArray(categories.data);
  }, [categories]);

  useEffect(() => {
    if (currentUserData) {
      setCurrentUserRole(currentUserData.role);
    }
  }, [currentUserData]);

  //const processorsListArray: any = [{ value: "", name: "Изабери категорију" }];

  const [papersData, setPapersData] = useState([{}]);
  const [buttonText, setButtonText] = useState<string>("Прикажи све");
  const [showAllPapers, setShowAllPapers] = useState(false);
  const [papers, setPapers] = useState("lastYear");
  const [papersTitle, setPapersTitle] = useState(
    `Деловодник за ${new Date().getFullYear()} годину`
  );
  const [pagesNumber, setPagesNumber] = useState(0);

  // Current active page
  const [activePage, setActivePage] = useState(1);

  // Page limit
  const [pageLimit, setPageLimit] = useState(10);

  // States connected to filter
  const [filterShown, setFilterShown] = useState(false);

  // Filter state
  const [filteredDocumentType, setFilteredDocumentType] = useState("");
  const [filteredArhived, setFilteredArhived] = useState("");
  const [sortByDateValue, setSortByDateValue] = useState("");
  const [filteredSort, setFilteredSort] = useState("");
  const [filteredCategoryType, setFilteredCategoryType] = useState("");
  const [filteredSubnumber, setFilteredSubnumber] = useState("");
  const [filteredProcessors, setFilteredProcessors] = useState("");
  const [filteredRecipientsSenders, setFilteredRecipientsSenders] =
    useState("");
  // Created at to/from states
  const [createdAtFrom, setCreatedAtFrom] = useState("");
  const [createdAtTo, setCreatedAtTo] = useState("");
  const [filteredByDateOfCreation, setFilteredByDateOfCreation] = useState("");
  const [filteredShortText, setFilteredShortText] = useState("");
  const [filteredSenderPaperNumber, setFilteredSenderPaperNumber] =
    useState("");
  const [query, setQuery] = useState("");
  // Sender date states
  const [senderDateFrom, setSenderDateFrom] = useState("");
  const [senderDateTo, setSenderDateTo] = useState("");
  const [filteredBySenderDate, setFilteredBySenderDate] = useState("");

  // State for selected category, depeends on this category give basic number
  const [selectedCategory, setSelectedCategory] = useState(
    categoryListArray[0].value
  );

  // State for storing value of base number
  const [baseNumber, setBaseNumber] = useState("");

  // Filter arrays
  const documentTypeArray = [
    {
      value: "",
      name: "Изабери",
    },
    {
      value: "&paperType=incoming",
      name: "Долазна",
    },
    {
      value: "&paperType=outgoing",
      name: "Одлазна",
    },
  ];

  const archivedArray = [
    {
      value: "",
      name: "Изабери",
    },
    {
      value: "&arhived=arhived",
      name: "Архивиран",
    },
    {
      value: "&arhived=notarhived",
      name: "Неархивиран",
    },
  ];

  // Sort options array

  const sortByDateArray = [
    {
      value: "",
      name: "Изабери",
    },
    {
      value: "createdAt",
      name: "Растући",
    },
    {
      value: "-createdAt",
      name: "Опадајући",
    },
  ];

  // Fake table data
  var tableData = {
    columns: [
      "Основни број",
      "Подброј",
      "Датум",
      "Кратак садржај",
      "Пошиљалац",
      "Тип",
      "Број акта пошиљаоца",
      "Датум акта пошиљаоца",
      "Обрађивач",
      "Архивиран",
      "Ажурирање",
    ],
    rows: papersData,
  };

  useEffect(() => {
    dispatch(getAllPagePapers(1, pageLimit, query));
    dispatch(allPapersNumber());
    dispatch(getCertainPagePapers(1, pageLimit, query));
    dispatch(getRecipientAndSenders());
    dispatch(currentYearPapersNumber(""));

    dispatch(getProcessors());
    //dispatch(getNotArchivedPagePapers(1, pageLimit));
    //dispatch(getNotArchivedPagePapers());
    dispatch(getCurrentUserData());
    dispatch(getCategories());

    // processors
    dispatch(getActiveProcessors());

    // archive
    //dispatch(getArchiveOfCurrentUser(1, pageLimit, query));
    //dispatch(getArchiveOfCurrentUserForCurrentYear(1, pageLimit, query));
    //dispatch(allArchiveNumber(""));
    //dispatch(currentYearArchiveNumber(""));
    dispatch(allArchiveNumber(""));
    //dispatch(getActiveCategories());
  }, []);

  useEffect(() => {
    setFilteredSort(`&sort=${sortByDateValue}`);
  }, [sortByDateValue]);

  useEffect(() => {
    if (certainPagePapers) {
      if (papers === "lastYear") {
        var certainPagePapersRow = certainPagePapers.map((element) => {
          const elementType = () => {
            if (element.paperType === "outgoing") {
              return "Одлазни документ";
            } else if (element.paperType === "incoming") {
              return "Долазни документ";
            } else {
              return "";
            }
          };
          return {
            "Основни број": element.baseNumber.baseNumber,
            Подброј: element.subnumber,
            Датум: element.createdAt ? element.createdAt.split("T")[0] : "",
            "Кратак садржај": element.shortText,
            Пошиљалац: element.recipientSender,
            Тип: elementType(),
            "Број акта пошиљаоца": element.senderPaperNumber,
            "Датум акта пошиљаоца": element.senderDate
              ? element.senderDate.split("T")[0]
              : "",
            Обрађивач:
              element.processor.firstName + " " + element.processor.lastName,
            Архивиран: element.arhived === "notarhived" ? "Не" : "Да",
            Ажурирање: element.id,
          };
        });
      } else if (papers === "all") {
        var certainPagePapersRow = allPagePapers.map((element) => {
          const elementType = () => {
            if (element.paperType === "outgoing") {
              return "Одлазни документ";
            } else if (element.paperType === "incoming") {
              return "Долазни документ";
            } else {
              return "";
            }
          };
          return {
            "Основни број": element.baseNumber.baseNumber,
            Подброј: element.subnumber,
            Датум: element.createdAt ? element.createdAt.split("T")[0] : "",
            "Кратак садржај": element.shortText,
            Пошиљалац: element.recipientSender,
            Тип: elementType(),
            "Број акта пошиљаоца": element.senderPaperNumber,
            "Датум акта пошиљаоца": element.senderDate
              ? element.senderDate.split("T")[0]
              : "",
            Обрађивач:
              element.processor.firstName + " " + element.processor.lastName,
            Архивиран: element.arhived === "notarhived" ? "Не" : "Да",
            Ажурирање: element.id,
          };
        });
      }
      setPapersData(certainPagePapersRow);
    }
  }, [certainPagePapers, allPagePapers, papers]);

  useEffect(() => {
    setPagesNumber(Math.ceil(currentYearPapers / pageLimit));
  }, [allPapers, currentYearPapers]);

  useEffect(() => {
    if (papers === "lastYear") {
      setPagesNumber(Math.ceil(currentYearPapers / pageLimit));
    } else if (papers === "all") {
      setPagesNumber(Math.ceil(allPapers / pageLimit));
    }
  }, [papers]);

  useEffect(() => {
    setBaseNumber("");
  }, [filterShown]);

  // On change basic
  const onSelectChange = (e, setValue) => {
    setValue(e.target.value);
  };

  // On category select change
  const onSelectCategoryChange = (e) => {
    setSelectedCategory(e.target.value);

    // Filter array and return object from choosen selected option
    let selectedObject: any = categoryListArray.filter((obj) => {
      return obj.value === e.target.value;
    });

    setBaseNumber(selectedObject[0].categoryNumber);

    if (e.target.value.length === 0) {
      setBaseNumber("");
      setFilteredCategoryType(``);
    }
    //setSubnumber(selectedObject[0].categoryNumber + 1);
    if (e.target.value.length > 0) {
      dispatch(getCertainCategoryPaperNumber(selectedObject[0].value));
      setFilteredCategoryType(`&baseNumber=${e.target.value}`);
    }
  };

  useEffect(() => {
    setQuery(
      filteredDocumentType +
        filteredCategoryType +
        filteredSubnumber +
        filteredArhived +
        filteredProcessors +
        filteredRecipientsSenders +
        filteredByDateOfCreation +
        filteredBySenderDate +
        filteredSenderPaperNumber +
        filteredShortText +
        filteredSort
    );
  }, [
    filteredDocumentType,
    filteredCategoryType,
    filteredSubnumber,
    filteredArhived,
    filteredProcessors,
    filteredRecipientsSenders,
    filteredByDateOfCreation,
    filteredBySenderDate,
    filteredSenderPaperNumber,
    filteredShortText,
    filteredSort,
  ]);

  // Filter, function for search searchDocuments
  const filterDocuments = () => {
    if (papers === "lastYear") {
      dispatch(getCertainPagePapers(1, pageLimit, query));
      setPagesNumber(Math.ceil(getCertainPagePapers.length / pageLimit));
    } else if (papers === "all") {
      dispatch(getAllPagePapers(1, pageLimit, query));
      setPagesNumber(Math.ceil(getCertainPagePapers.length / pageLimit));
    }
  };

  return (
    <>
      {currentUserRole && currentUserRole === "pending" ? (
        <p className={css.pendingMessage}>
          Немате дозволу за ову акцију! Сачекајте одобрење од администратора.
          Уколико не добијете одобрење позовите на број 064/6386892
        </p>
      ) : (
        <div className={css.container}>
          <NavigationBar />

          {categoriesAll && categoriesAll.length > 0 ? (
            <div className={css.contentContainer}>
              {/* Title part, title is dynamic */}
              <h1>{papersTitle}</h1>
              {/* Papers navigation */}
              <PapersNavigation
                buttonText={buttonText}
                setPapersData={setPapersData}
                allPagePapers={allPagePapers}
                certainPagePapers={certainPagePapers}
                setPapers={setPapers}
                setButtonText={setButtonText}
                setPapersTitle={setPapersTitle}
                setActivePage={setActivePage}
                activePage={activePage}
                pageLimit={pageLimit}
              />{" "}
              {/* Filter */}
              {allPagePapers && allPagePapers.length > 0 && (
                <div
                  className={css.showFilterContainer}
                  onClick={() => setFilterShown((prevState) => !prevState)}
                >
                  {!filterShown && <p>Прикажи филтер</p>}
                  {filterShown && <p>Сакриј филтер</p>}
                  {!filterShown && (
                    <RiArrowDownCircleLine className={css.icon} />
                  )}
                  {filterShown && <RiArrowUpCircleLine className={css.icon} />}
                </div>
              )}
              {filterShown && (
                <Filter
                  onSelectDocumentTypeChange={(e) =>
                    onSelectChange(e, setFilteredDocumentType)
                  }
                  filterArray={documentTypeArray}
                  onSelectCategoryChange={onSelectCategoryChange}
                  categoryArray={categoryListArray}
                  setFilteredSubnumber={setFilteredSubnumber}
                  onSelectArchivedChange={(e) =>
                    onSelectChange(e, setFilteredArhived)
                  }
                  onSelectSortByDateChange={(e) => {
                    onSelectChange(e, setSortByDateValue);
                  }}
                  archivedArray={archivedArray}
                  onSelectProcessorChange={(e) =>
                    onSelectChange(e, setFilteredProcessors)
                  }
                  processorArray={processorsListArray}
                  setCategoryListArray={setCategoryListArray}
                  categoriesArray={categoriesArray}
                  activeProcessors={allProcessors}
                  setProcesorsListArray={setProcesorsListArray}
                  baseNumber={baseNumber}
                  recipientSenderArray={allRecipientsSenders}
                  onSelectRecipientSenderChange={(e) => {
                    onSelectChange(e, setFilteredRecipientsSenders);
                  }}
                  setRecipientsSendersListArray={setRecipientsSendersListArray}
                  recipientsSendersListArray={recipientsSendersListArray}
                  filteredByDateOfCreation={filteredByDateOfCreation}
                  setCreatedAtFrom={setCreatedAtFrom}
                  setCreatedAtTo={setCreatedAtTo}
                  createdAtFrom={createdAtFrom}
                  createdAtTo={createdAtTo}
                  setFilteredByDateOfCreation={setFilteredByDateOfCreation}
                  senderDateFrom={senderDateFrom}
                  senderDateTo={senderDateTo}
                  filteredBySenderDate={filteredBySenderDate}
                  setSenderDateFrom={setSenderDateFrom}
                  setSenderDateTo={setSenderDateTo}
                  setFilteredBySenderDate={setFilteredBySenderDate}
                  setFilteredSenderPaperNumber={setFilteredSenderPaperNumber}
                  setFilteredShortText={setFilteredShortText}
                  sortByDateArray={sortByDateArray}
                  setFilteredSort={setFilteredSort}
                  type="papers"
                />
              )}
              {filterShown && (
                <div className={css.buttonWrapper}>
                  <Button
                    text="Претражи документа"
                    onButtonClickHandler={() => filterDocuments()}
                    type="filterButton"
                  />
                </div>
              )}
              {/* Table component */}
              {allPagePapers && allPagePapers.length > 0 && (
                <div className={css.tableWrapper}>
                  <TableComponent data={tableData} tableType="paper" />
                </div>
              )}
              {/* Pagination */}
              <Pagination
                pagesNumber={pagesNumber}
                papers={papers}
                activePage={activePage}
                setActivePage={setActivePage}
                allPagePapers={certainPagePapers}
                certainPagePapers={certainPagePapers}
                pageLimit={pageLimit}
                query={query}
              />
            </div>
          ) : (
            <div>
              <Link to="/categories">
                <p className={css.enterCategories}>
                  Кликните овде да унесете категорије
                </p>
              </Link>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Papers;
